__turbopack_context__.v({
  "active": "tabs-module-scss-module__bW1cma__active",
  "tabContent": "tabs-module-scss-module__bW1cma__tabContent",
  "tabTrigger": "tabs-module-scss-module__bW1cma__tabTrigger",
  "tabs": "tabs-module-scss-module__bW1cma__tabs",
  "tabsList": "tabs-module-scss-module__bW1cma__tabsList",
});
